export const EMAIL_VERIFICATION_PAGE_TITLE = 'email-verification-page.title';
export const EMAIL_VERIFICATION_PAGE_VERIFICATION_DESCRIPTION = 'email-verification-page.verification-description';
export const EMAIL_VERIFICATION_PAGE_ICON_ALT = 'email-verification-page.icon-alt';
